import { ICultureDTO, LocalizationsDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import { IListQueryResult, IQueryResult } from 'src/api/types';

export default class LocalizationRepository extends CommonRepository {
  private static readonly baseRoute = '/localizations';
  private static readonly apiURL = LocalizationRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<LocalizationsDTO> => {
    try {
      const { data } = await http.get<IQueryResult<LocalizationsDTO>>(LocalizationRepository.apiURL);
      return data.item;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getCultures = async (): Promise<ICultureDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<ICultureDTO>>(`${LocalizationRepository.apiURL}/cultures`);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
